/**
 * Maps plan names for display. "Benefits only" is shown as "Stand Alone Benefits".
 * @param {string|null|undefined} planName
 * @returns {string|null} Display name or original if no mapping
 */
export function formatPlanNameForDisplay(planName) {
  if (planName == null || planName === '') return planName;
  const s = String(planName).trim();
  const lower = s.toLowerCase();
  if (lower === 'benefits only') return 'Stand Alone Benefits';
  if (lower === 'standalone benefits') return 'Stand Alone Benefits';
  return s;
}
